const measureBankTypes = {
  Strengths: 1,
  Needs: 2,
  Justifications: 3,
};

export default measureBankTypes;
